import type { AvvirEvent } from "type_aliases";

export type UserPermissionDeletedEvent = AvvirEvent<typeof USER_PERMISSION_DELETED, number>

const userPermissionDeleted = (permissionId: number): UserPermissionDeletedEvent => ({
  type: USER_PERMISSION_DELETED,
  payload: permissionId
});

export const USER_PERMISSION_DELETED = "user_permission_deleted";

export default userPermissionDeleted;
